import { HIDE_MODAL } from "core-web/state/models/Modal/constants";
import store from "core-web/state/store";

const hideModal = () => (dispatch) => {
    dispatch({
        type: HIDE_MODAL,
    });
};

export default () => store.dispatch(hideModal());
